import HttpClient from '../../HttpClient/NewApi';

export default {
    cancel(salesOrderId) {
        return HttpClient
            .patch(`/api/v1/sales-orders/${salesOrderId}/cancel`);
    }
}


// WEBPACK FOOTER //
// ./apiClient/SalesOrder/Cancel/index.js